export const requestResultSelector = (state) => {
    return state.resetPassword.records.requestResult;
};

export const confirmResultSelector = (state) => {
    return state.resetPassword.records.confirmResult;
};
